document.addEventListener('DOMContentLoaded', function() {
  const players = document.querySelectorAll('.custom-audio-player');
  
  players.forEach(function(player) {
    const audio = player.querySelector('audio');
    if (!audio) return;
    
    const playPauseBtn = player.querySelector('.play-pause-btn');
    const playIcon = playPauseBtn.querySelector('.play-icon');
    const pauseIcon = playPauseBtn.querySelector('.pause-icon');
    const progressFill = player.querySelector('.progress-fill');
    const progressBar = player.querySelector('.progress-bar');
    const currentTimeEl = player.querySelector('.current-time');
    const durationEl = player.querySelector('.duration');
    const volumeBtn = player.querySelector('.volume-btn');
    const volumeSlider = player.querySelector('.volume-slider');
    
    // Play/Pause
    playPauseBtn.addEventListener('click', function() {
      if (audio.paused) {
        audio.play();
        playIcon.style.display = 'none';
        pauseIcon.style.display = 'block';
      } else {
        audio.pause();
        playIcon.style.display = 'block';
        pauseIcon.style.display = 'none';
      }
    });
    
    // Update progress bar
    audio.addEventListener('timeupdate', function() {
      const progress = (audio.currentTime / audio.duration) * 100;
      progressFill.style.width = progress + '%';
      currentTimeEl.textContent = formatTime(audio.currentTime);
    });
    
    // Set duration when loaded
    audio.addEventListener('loadedmetadata', function() {
      durationEl.textContent = formatTime(audio.duration);
    });
    
    // Seek functionality
    progressBar.addEventListener('click', function(e) {
      const rect = progressBar.getBoundingClientRect();
      const percent = (e.clientX - rect.left) / rect.width;
      audio.currentTime = percent * audio.duration;
    });
    
    // Volume control
    volumeSlider.addEventListener('input', function() {
      audio.volume = this.value / 100;
    });
    
    // Mute/unmute
    volumeBtn.addEventListener('click', function() {
      if (audio.volume > 0) {
        audio.volume = 0;
        volumeSlider.value = 0;
      } else {
        audio.volume = 1;
        volumeSlider.value = 100;
      }
    });
    
    // Format time helper
    function formatTime(seconds) {
      if (isNaN(seconds)) return '0:00';
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return mins + ':' + (secs < 10 ? '0' : '') + secs;
    }
    
    // Reset on end
    audio.addEventListener('ended', function() {
      playIcon.style.display = 'block';
      pauseIcon.style.display = 'none';
      progressFill.style.width = '0%';
      audio.currentTime = 0;
    });
  });
});
